import './support/patchHistory';
import './support/styleLoaderApp';
import './polyfill/all';
import './support/filterConsoleWarnings';

import React from 'react';
import ReactDOM from 'react-dom';

import App from './components/App';
import AuthTokenValidator from './components/AuthTokenValidator';
import { AuthStateProvider } from './components/AuthState';
import { SeasonStateProvider } from './components/SeasonState';
import ApolloProvider from './api/ApolloProvider';
import { AppConfigProvider } from './AppConfig';
import { ThemeProvider } from './core-ui';
import { GlobalRouter } from './components/Navigation';
import DataStore from './support/DataStore';
import DocumentDragDrop from './support/helpers/DocumentDragDrop';
import BrowserUpdateNotice from './components/App/BrowserUpdateNotice';
import { ReleaseNotesProvider } from './components/ReleaseNotesProvider';
import { QueryProvider } from './api/QueryProvider';

const dataStore = DataStore.getInstance('app');
dataStore.set('entryPoint', 'app');

// Disallow [drag] dropping of arbitrary files/links.
DocumentDragDrop.disallow();

// Remove the main script tag before rendering.
let scripts = document.querySelectorAll('script');
let mainScript = scripts[scripts.length - 1];

document.addEventListener('DOMContentLoaded', () => {
  if (mainScript != null && mainScript.parentNode != null) {
    mainScript.parentNode.removeChild(mainScript);
  }

  let container = document.querySelector('#app');

  if (container) {
    ReactDOM.render(
      <ApolloProvider>
        <QueryProvider>
          <AppConfigProvider>
            <ThemeProvider>
              <AuthTokenValidator>
                <AuthStateProvider>
                  <SeasonStateProvider>
                    <ReleaseNotesProvider>
                      <GlobalRouter>
                        <App />
                        <BrowserUpdateNotice />
                      </GlobalRouter>
                    </ReleaseNotesProvider>
                  </SeasonStateProvider>
                </AuthStateProvider>
              </AuthTokenValidator>
            </ThemeProvider>
          </AppConfigProvider>
        </QueryProvider>
      </ApolloProvider>,
      container,
    );
  }
});
